// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_code_values

export default class Keyboard {
  private static downHandlers: Map<
    string,
    Set<(event: KeyboardEvent) => void>
  > = new Map();
  private static upHandlers: Map<string, Set<(event: KeyboardEvent) => void>> =
    new Map();

  private static pressedKeys: Set<string> = new Set();

  static init() {
    window.addEventListener("keydown", this.onKeyDown.bind(this));
    window.addEventListener("keyup", this.onKeyUp.bind(this));
  }

  private static onKeyDown(event: KeyboardEvent) {
    this.pressedKeys.add(event.code);
    for (const handler of Keyboard.downHandlers.get(event.code) ?? []) {
      handler(event);
    }
  }
  private static onKeyUp(event: KeyboardEvent) {
    this.pressedKeys.delete(event.code);
    for (const handler of Keyboard.upHandlers.get(event.code) ?? []) {
      handler(event);
    }
  }

  static isDown(key: string) {
    return this.pressedKeys.has(key);
  }

  static up(keys: string | string[], handler: (event: KeyboardEvent) => void) {
    if (!Array.isArray(keys)) keys = [keys];
    for (const key of keys) {
      if (!Keyboard.upHandlers.has(key))
        Keyboard.upHandlers.set(key, new Set());
      Keyboard.upHandlers.get(key)!.add(handler);
    }
  }
  static down(
    keys: string | string[],
    handler: (event: KeyboardEvent) => void
  ) {
    if (!Array.isArray(keys)) keys = [keys];
    for (const key of keys) {
      if (!this.downHandlers.has(key))
        Keyboard.downHandlers.set(key, new Set());
      Keyboard.downHandlers.get(key)!.add(handler);
    }
  }

  static unup(
    keys: string | string[],
    handler: (event: KeyboardEvent) => void
  ) {
    if (!Array.isArray(keys)) keys = [keys];
    for (const key of keys) {
      if (!Keyboard.upHandlers.has(key)) return;
      Keyboard.downHandlers.get(key)!.delete(handler);
    }
  }
  static undown(
    keys: string | string[],
    handler: (event: KeyboardEvent) => void
  ) {
    if (!Array.isArray(keys)) keys = [keys];
    for (const key of keys) {
      if (!Keyboard.downHandlers.has(key)) return;
      Keyboard.downHandlers.get(key)!.delete(handler);
    }
  }
}

Keyboard.init();
